module.exports = __webpack_public_path__ + "img/SuccessfulIcon.ea562b02.svg";